import script from "./UserEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserEditModal.vue?vue&type=style&index=0&id=73940fc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73940fc0"]])

export default __exports__